module.exports = __webpack_public_path__ + "media/images/food-bg-b778a74cd7d3935454b1051f28b3e816.png";